import React, { useEffect } from "react";
import styles from "./Footer.module.scss";
import imgLogo from "../../../assets/images/SNSW_POL_Logo.png";
import { withRouter } from "react-router-dom";
import moment from "moment";

const Footer = props => {
  useEffect(
    () => {
      //window.onload = function () {
      document.getElementById("container-loader").style.display = "none";
      //throw new Error('I crashed!');   
      //};
    },
    []
  );

  return (<>
    <div className={`${styles.upperFooterContainer}`}>
      <div className={`${styles.upperFooter}`}>
        <ul>
          <li className={`${styles.item}`}>
            <img
              src={imgLogo}
              alt="NSW Government Logo"
              className={styles.logo}
            />
          </li>
          <li className={`${styles.item}`}>
          <strong>Address</strong>
          <br />
          Locked Bag 5099
          <br />
          PARRAMATTA NSW 2124
          <br />
          Australia
        </li>
          <li className={`${styles.item}`}>
            <ul>
              <li>
                <div className={`${styles.phone}`}>
                  <div>
                    <div><strong>Phone</strong></div>
                    <div>1300 362 001</div>
                  </div>
                </div>
              </li>
              <li>
                <div className={`${styles.fax}`}>
                  <div><strong>Website</strong></div>
                  <div><a href="https://www.police.nsw.gov.au/sled" target="_blank">https://www.police.nsw.gov.au/sled</a></div>
                </div>
              </li>
            </ul>
            <li>
              <div className={`${styles.email}`}>
                <div><strong>Email</strong></div>
                <div><a href="mailto:sled@police.nsw.gov.au">sled@police.nsw.gov.au</a></div>
              </div>
            </li>
          </li>
        </ul>
      </div>
    </div>
    <footer>
      <div className={styles.footerContainer}>
        <div className={styles.footer}>
          <p>We pay respect to the Traditional Custodians and First Peoples of NSW, and acknowledge their continued
          connection to their country and culture.</p>
          <small className={styles.small}>Copyright © {moment().format("YYYY")} Department of Customer Service</small>
        </div>
      </div>
    </footer>
  </>)
};

export default withRouter(props => <Footer {...props} />);
